<template>
  <v-list-item v-if="listItem"
               two-line
               @click="$emit('onMarkAllAsRead')">
    <v-list-item-icon>
      <v-icon>mdi-checkbox-multiple-marked-outline</v-icon>
    </v-list-item-icon>
    <v-list-item-content>

      <v-list-item-subtitle class="wrap-normal"> {{ $t('markAllAsRead') }}</v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>

  <v-tooltip v-else
             bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn x-small
             icon
             v-bind="attrs"
             v-on="on"
             @click.stop="$emit('onMarkAllAsRead')"
             :color="color">
        <v-icon>mdi-checkbox-multiple-marked-outline</v-icon>
      </v-btn>
    </template>
    <span>{{ $t('readAll.documents.tooltip') }}</span>
  </v-tooltip>
</template>

<script>
import common from '@/mixins/common';

export default {
  name: 'MarkAllAsReadButton',
  mixins: [common],
  props: {
    listItem: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
    },
  },
};
</script>
